module.exports = __webpack_public_path__ + "media/base/customer_phone-10dc7ab6.svg";